<template>
  <ul class="product-reason">
    <li
      v-for="(reasons, i) in product.rejectReasons"
      :key="i"
    >
      {{ reasons }}
    </li>
  </ul>
</template>
<script>
export default {
  name: 'RejectReason',
  props: {
    product: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>
